import $ from 'jquery';
import nav from './nav';
import Footer from './footer';
import Accolades from './accolades';
import HomeSuccess from './home-success';
import LeftMenuContainer from './left-menu-container';
import Hero from './hero';
import Filter from './filter';
import PeopleGrid from './people-grid';
import ProfileCopy from './profile-copy';
import FeaturedPeople from './featured-people';
import NewsGrid from './news-grid';
import DisclaimerModal from './disclaimer-modal';
import ProfileDetail from './profile-detail';
import LawschoolConnect from './lawschool-connect';
import Contact from './contact';
import GroupsButton from './groups-button';
import ContentBlockCases from './content-block-cases';
import ContentBlockExpandable from './content-block-expandable';
import SearchResultsContainer from './search-results-container';
import ProfileRepCases from './profile-rep-cases';
import CookieBanner from './cookie-banner';
import PodcastsModule from './podcasts-module';


$(function() {
  // primary
  const navigation = new nav($('.nav-module'));
  const footer = new Footer($('.footer-module'));

  //partials
  const $hero = $('.hero-module');
  if($hero.length) {
    const hero = new Hero($hero);
  }
  const $homeSuccess = $('.home-success-module');
  if($homeSuccess.length) {
    const homeSuccess = new HomeSuccess($homeSuccess);
  }
  const $leftMenuContainer = $('.left-menu-container-module');
  if($leftMenuContainer.length) {
    const leftMenuContainer = new LeftMenuContainer($leftMenuContainer);
  }
  const $filterModule = $('.filter-module');
  if($filterModule.length) {
    const filter = new Filter($filterModule);
  }
  const $peopleGridModule = $('.people-grid-module');
  if($peopleGridModule.length) {
    const peopleGrid = new PeopleGrid($peopleGridModule);
  }

  const $profileCopy = $('.profile-copy-module');
  if($profileCopy.length) {
    const profileCopy = new ProfileCopy($profileCopy);
  }

  const $featuredPeople = $('.featured-people-module');
  if($featuredPeople.length) {
    const featuredPeople = new FeaturedPeople($featuredPeople);
  }
  const $newsGridModule = $('.news-grid-module');
  if($newsGridModule.length) {
    const newsGridModule = new NewsGrid($newsGridModule);
  }
  const $disclaimerModal = $('.disclaimer-modal-module');
  if($disclaimerModal.length) {
    const disclaimerModal = new DisclaimerModal($disclaimerModal);
  }

  const $profileDetail = $('.profile-detail-module');
  if($profileDetail.length) {
    const profileDetail = new ProfileDetail($profileDetail);
  }

  const $lawSchoolConnect = $('.lawschool-connect-module');
  if($lawSchoolConnect.length) {
    const lawSchoolConnect = new LawschoolConnect($lawSchoolConnect);
  }

  const $contact = $('.contact-module');
  if($contact.length) {
    const contact = new Contact($contact);
  }

  const $groupsButton = $('.group-button-module');
  if($groupsButton.length) {
    const groupsButton = new GroupsButton($groupsButton);
  }
  const $accolades = $('.accolades-module');
  if($accolades.length) {
    const accolades = new Accolades($accolades);
  }

  const $contentBlockCases = $('.content-block-cases-module');
  $contentBlockCases.each(function() {
    const contentBlockCases = new ContentBlockCases($(this));
  });
  
  const $contentBlockExpandable = $('.content-block-expandable-module');
  $contentBlockExpandable.each(function() {
    const contentBlockExpandable = new ContentBlockExpandable($(this));
  });
  
  const $searchResultsContainer = $('.search-results-container-module');
  if($searchResultsContainer.length) {
    const searchResultsContainer = new SearchResultsContainer($searchResultsContainer);
  }

  const $profileRepCases = $('.profile-rep-cases-module');
  if($profileRepCases.length) {
    const profileRepCases = new ProfileRepCases($profileRepCases);
  }

  const $cookieBanner = $('.cookie-banner-module');
  if($cookieBanner.length) {
    const cookieBanner = new CookieBanner($cookieBanner)
  }

  const $podcastsModule = $('.podcasts-module');
  if($podcastsModule.length) {
    const podcastsModule = new PodcastsModule($podcastsModule)
  }


});